import { render, staticRenderFns } from "./AlertView.vue?vue&type=template&id=05b425ba&scoped=true&"
import script from "./AlertView.vue?vue&type=script&lang=js&"
export * from "./AlertView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b425ba",
  null
  
)

export default component.exports